export default __webpack_public_path__ + "static/distributors-78eaedc6cc75a60eab09e2d8431353de.png";